const pluvaMarket = {
  header: '플루바 마켓 회원 이용약관(EULA)',
  content: `
이 최종 사용자 라이센스 계약서("EULA")는 사용자와 GINT CO.,Ltd.(이하 "긴트") 사이의 법적 계약입니다. 사용자는 본 계약을 자세히 읽은 후 소프트웨어를 설치하거나 긴트 제품을 사용해야 합니다. 본 소프트웨어를 설치하거나 긴트 제품을 사용할 경우 본 EULA의 조항에 구속됨을 동의하는 것입니다.

본 EULA의 조항에 동의하지 않을 경우, 구입처의 관련 반환 정책의 약관에 따라 환불을 위해 제품을 반환할 수 있습니다. 귀하가 자국 또는 거주 지역의 법적 최저 연령 미만인 경우, 부모 또는 법적 보호자가 EULA 약관을 읽고 수락해야 합니다.

아래 4절에서 기술한 것처럼 사용자는 자동 소프트웨어 업데이트에 동의하는 것입니다. 동의하지 않으면 제품을 사용하거나 소프트웨어를 설치하지 못합니다. 아래의 제품 제한 절은 생명 안전 및 중요 사용과 관련하여 소프트웨어 및 관련 서비스의 중요한 제한 사항을 설명합니다. 이 절은 이해와 동의가 요구되므로 신중히 읽으십시오. “소프트웨어”는 다음을 의미합니다.

(i) 데스크톱 또는 모바일 장치에 다운로드하여 설치한 소프트웨어 응용 프로그램을 포함한 모든 소프트웨어 프로그램 또는 응용 프로그램
(ii) 긴트 제품에 내장된 소프트웨어 형태의 모든 소프트웨어
(iii) 그러한 소프트웨어의 관련 문서, 수정된 버전, 업그레이드 또는 개선 기능(업데이트 또는 다운로드 시점에서 다른 약관 하에 제공되지 않는 한), 그러한 소프트웨어의 모든 후속 버전, 사본(총칭하여 “소프트웨어”라고 함)을 의미합니다.

이 조항은 사용자에게 구체적인 법적 권리를 부여하며 사용자는 또한 관할권에 따라 다른 법적 권리를 추가로 갖습니다.

1. 라이센스.
  본 EULA의 조건에 따라 긴트은 사용자가 구입한 긴트 제품 또는 사용한 긴트 서비스에 한해 소프트웨어를 사용할 수 있도록 사용자에게 제한적인 비독점적 사용권을 부여합니다. 이 소프트웨어는 로지텍 제품에 내장되어 있는 경우를 제외하고 사용자가 본 소프트웨어의 사용을 지원하기 위해 백업 또는 보관 목적만으로 복사할 수 있으며 가정 내 또는 사내 네트워크 서버에서 사용자의 소유 또는 관리하에 있는 장치에 다운로드하기 위한 목적으로 하며 여기에 명시된 대로 소프트웨어를 사용하기 위한 목적으로만 사용할 수 있습니다. 모든 사본에는 원본에 포함된 모든 저작권 및 기타 소유권 고지 사항이 포함되어야 합니다. 긴트 제품에 내장된 소프트웨어의 경우, 사용자 소유 또는 통제 하의 긴트 제품에서만 또는 사용자에 의해 사용되는 긴트 서비스를 통해서 하나의 사본만 사용할 수 있습니다. 사용자는 이 소프트웨어를 사용하는 긴트 제품을 영구적으로 양도할 경우 해당 사용자가 본 EULA에 동의하는 한 타인에게 소프트웨어를 영구적으로 양도할 수 있으며 그러한 양도 후에는 제품 및 소프트웨어 사용을 중단할 수 있습니다.

2. 제한 사항.
  사용자에게 부여된 제한 사항은 다음과 같습니다. (A) 소프트웨어의 사용권 부여, 판매, 임대, 대여, 양도(1절에서 명시적으로 허용된 경우는 제외), 배포, 호스팅, 외주, 공개 또는 달리 상업적으로 악용하거나 제3자에게 소프트웨어를 제공하는 행위 (B) 소프트웨어를 복사하는 행위(1절에서 명시적으로 허용된 경우는 제외) (C) 소프트웨어 또는 그 일부에 대한 소스 코드의 디컴파일링, 디어셈블링, 역엔지니어링 또는 파생 작업을 하거나 설치 프로그램을 만들려고 시도하는 행위(해당 법률에서 명시적으로 허용할 경우는 제외) (D) 소프트웨어에 있는 상표, 로고, 저작권 또는 기타 독점적 고지, 범례, 기호 또는 레이블을 삭제 또는 변형하려는 행위를 해서는 안 되며 타인에게 그러한 행위를 허락해서도 안 됩니다.

3. 소유권.
  긴트 및 해당 사용권 허가자는 소프트웨어 및 모든 저작권 및 기타 지적 재산권에 대한 모든 권리, 소유권 및 이권을 소유 및 보유합니다. 이 소프트웨어는 긴트에 의해 사용자에게 판매되는 것이 아니라 사용권을 부여한 것으로 긴트은 사용자에게 명시적으로 부여되지 않은 모든 권리를 보유합니다.

4. 자동 소프트웨어 업데이트.
  긴트는 때때로 버그 수정, 업데이트, 업그레이드 및 기타 소프트웨어 수정 사항(이하 "업데이트")을 제공할 수 있습니다. 이것은 추가 공지 또는 추가 동의 없이 자동으로 설치될 수 있습니다. 사용자는 이 자동 업데이트에 동의합니다. 그러한 업데이트를 원하지 않는다면 제품 사용을 중단하십시오. 본 EULA 조건은 원래 소프트웨어를 교체하거나 보완하는 긴트에서 제공하는 모든 업데이트에 적용됩니다. 단 그러한 업데이트가 별도의 사용권과 함께 제공되는 경우 해당 사용권의 조건이 적용됩니다.

5. 앱 스토어(App Store).
  Apple App Store, Apple Mac Store 또는 Google Play(이하 "App Store")와 같은 애플리케이션 시장 또는 매장에서 소프트웨어를 다운로드한 경우 사용자는 해당 App Store 이용 약관의 적용을 받습니다. 사용자의 소프트웨어 사용이 App Store의 이용 약관의 적용을 받는 경우, App Store의 사용 약관과 본 EULA 간에 상충되거나 모호한 경우, App Store의 사용은 적용되지만, 그러한 분쟁이나 모호성을 해결하는 데 필요한 범위까지만 적용되며, 본 EULA의 조항은 완전한 효력을 유지합니다. 사용자는 (i) 본 EULA가 App Store가 아닌 긴트과 사용자 간에 체결된 것이며; (ii) App Store는 다운로드한 소프트웨어와 관련해서 어떤 지원이나 유지보수를 제공할 의무가 없으며; (iii) 본 EULA에 제공된 대로 지정된 범위까지 App Store가 아닌 긴트이 App Store에서 다운로드한 소프트웨어의 제품 보증, 제품 청구 및 지적재산 청구에 대한 책임이 있고, 어떤 경우에도 보증에 대한 App Store의 최대 책임은 소프트웨어의 구매 가격 환불로 국한되며; (iv) Apple과 해당 자회사는 Apple App Store 및 Mac Store에서 다운로드한 소프트웨어에 대해 본 EULA의 제3의 수혜자임을 확인합니다.

6. 개인정보보호.
  당사의 개인정보 관련 관행은 긴트 개인정보약관을 비롯하여 소프트웨어, 앱, 제품 또는 서비스를 구매하거나 다운로드하거나 사용할 때 제공되는 별도의 개인정보 보호 설명문(통칭하여 “개인정보 보호정책”이라 함)에 나와 있습니다. 본 소프트웨어를 설치하고 긴트 제품을 이용하거나 당사에 개인 정보를 제공할 경우, 사용자는 개인정보 보호정책 및 별도의 개인정보 보호 설명문에 기술된 관행, 조건과 조항을 동의하는 것입니다. 당사의 개인정보 보호정책은 본 EULA에 참고 자료로 통합되어 있습니다.

7. 오픈 소스.
  본 EULA는 소프트웨어에 포함될 수 있는 모든 오픈 소스 소프트웨어(이하 "오픈 소스 구성 요소")에는 적용되지 않습니다. 각 오픈 소스 구성 요소의 사용에는 해당 오픈 소스 구성 요소에 수반되는 각 해당 최종 사용자 사용권 조항이 적용됩니다. 이와 같은 각각의 해당 사용권 조항에 동의하지 않을 경우 소프트웨어를 사용할 수 없습니다. 본 EULA의 어떤 내용도 오픈 소스 구성 요소에 대한 해당 최종 사용자 사용권의 조건을 사용자에게 부여하는 권리를 제한하거나 사용자에게 부여하는 권리를 대체하지 않습니다.

8. 제3자 소프트웨어.
  소프트웨어 및 제품은 다른 제품 및 소프트웨어와 관련하여 사용될 수 있으며 타사 소프트웨어(이하 "제3자 소프트웨어")의 콘텐츠 및 데이터와 링크 또는 인터페이스를 포함할 수 있습니다. 그러한 제3자 소프트웨어의 사용에는 제3자의 개인정보 보호정책을 포함하여 해당 제3자 소프트웨어의 사용 허가자가 제공하는 조건이 적용됩니다. 제3자 소프트웨어에 접속하거나 그것을 이용하면 관련 제3자 조건에 동의하는 것입니다. 긴트은 그러한 제3자 소프트웨어의 작동 또는 제공 여부에 대해 어떠한 진술이나 보증도 하지 않습니다. 긴트 또는 해당 라이센스 제공자는 이러한 제3자 소프트웨어의 제공 불가 여부 또는 제거에 대해 책임을 지지 않습니다.

9. 계약 해지.
  본 EULA는 해지될 때까지 계속됩니다. 양쪽 당사자 중 누구나 언제든지 어떤 사유로든 본 EULA를 해지할 수 있습니다. 사용자의 소프트웨어 사용권은 사용자가 본 EULA의 조건을 위반하는 경우 긴트의 통지 없이 자동으로 해지됩니다. 그러한 해지 시, 사용자는 소프트웨어 사용을 중지하고 소유하고 있거나 관리하고 있는 소프트웨어 사본을 모두 제거해야 합니다. 조항 6, 7, 8, 9 10, 11, 12, 16, 17 및 18절은 그러한 해지 후에도 유효합니다. 긴트은 소프트웨어 또는 업데이트의 향후 제공 여부에 대한 어떠한 진술도 하지 않으며 소프트웨어 또는 업데이트의 제공 불가 여부 또는 제거에 대해 책임지지 않습니다. 긴트은 본 소프트웨어와 관련하여 유지 보수 또는 지원 서비스를 제공할 책임을 지지 않습니다.
  
10. 보증 면책 사항.
  해당 법에서 허용하는 최대 한도까지, 긴트 소프트웨어 및 서비스는 모든 결함과 함께 어떠한 보증 없이 "있는 그대로" 제공됩니다. 해당 법에서 허용하는 한도까지 긴트 소프트웨어 및 서비스 사용에 대한 위험 및 만족스러운 품질, 성능, 정확성 및 최선의 서비스에 관한 위험은 사용자 자신이 부담함을 인정하고 이에 동의합니다. 긴트과 긴트 라이센서는 묵시적 보증 및/또는 상업성, 만족스러운 품질, 특정 목적에 대한 적합성, 정확성, 묵시적 권리 보유에 대한 조건, 제 3자의 권리 침해 등 긴트 소프트웨어 및 서비스에 대한 모든 명시적, 묵시적 또는 법적 보증 등 모든 보증과 조건을 부인합니다. 긴트는 사용자의 긴트 소프트웨어 또는 서비스의 권리 보유에 대한 간섭을 보증하지 않으며, 긴트 소프트웨어 또는 서비스에 포함되는 기능이 사용자의 요구 사항을 만족하리라 보증하지 않으며, 긴트 소프트웨어 또는 서비스의 작동이 중단되지 않거나 오류가 없다고 보증하지 않으며, 긴트 소프트웨어 또는 서비스 결함의 수정을 보증하지 않습니다. 긴트의 딜러나 대리인 또는 직원은 본 보증의 부인을 수정, 확대 또는 추가할 수 있는 권한이 없습니다. 일부 사법권역에서는 묵시적 보증에 대한 배제나 소비자의 법적 권리에 대한 제한을 허용하지 않으므로 위의 제한 또는 배제가 사용자에게 적용되지 않을 수도 있습니다.
  
11. 책임 제한.
  해당 법에서 금지하지 않는 한도까지, 긴트이 손해의 가능성을 통보받은 경우라도, 책임론(계약, 불법 행위 등)에 상관없이 어떤 경우에도 긴트 또는 긴트 라이센서는 긴트 제품, 소프트웨어 또는 서비스의 판매, 사용권 부여, 사용 또는 사용 불능에서 야기된 대체 제품 또는 서비스 구입, 이익 손실, 정보 손실, 데이터 손실 또는 기타 특별, 간접, 필연 또는 부수적 손해에 대해 책임을 지지 않습니다. 긴트과 긴트 라이센서는 어떠한 경우에도 해당 제품, 소프트웨어의 실제 구입 가격을 초과하거나 책임져야 할 서비스를 초과하여 책임을 지지 않습니다. 상기 제한은 위에 명시된 구제책이 가장 중요한 목적을 달성하지 못한 경우에도 관계없이 해당됩니다. 일부 관할권에서는 부수적 또는 필연적 손해에 대한 예외 또는 제한을 허용하지 않으므로 위에 언급된 제한 또는 예외가 적용되지 않을 수도 있습니다. 위의 제한은 적용법이 지정하는 범위 및 정도에 따라 개인적인 상해의 경우에는 적용되지 않습니다.
  
12. 제품 제한.
  소프트웨어는 소프트웨어 결함이 사망, 상해 또는 심각한 물리적 또는 환경적 손상을 이끌 수 있는 핵 시설, 항법 또는 통신 시스템, 항공 관제 시스템, 의료 장치 또는 기타 장비 운용에 사용되지 않습니다. 사용자는 이 소프트웨어가 응급 목적으로 인증되지 않았으며 본 목적을 위해 사용되어서는 안 된다는 사실을 인정합니다. 긴트은 긴급 사태 통지를 모니터링하지 않으며 사용자의 가정에 긴급 서비스를 제공하지 않습니다.
  
13. 미국 정부 최종 사용자.
  소프트웨어는 48 C.F.R. 2.101에 정의된 용어로 "상용 컴퓨터 소프트웨어" 및 "상용 컴퓨터 소프트웨어 문서"로 구성되는 "상용 품목"이며, 미국 정부 최종 사용자에게 (a) 상용 품목으로써만 사용권이 부여되며, (b) 그러한 권리는 본 EULA의 약관에 따라 기타 모든 최종 사용자에게 부여됩니다. 미국 저작권 법에 따라 보유되는 공표되지 않은 권리.
  
14. 수출법 보장.
  사용자는 미국, 유럽 연합, 스위스 및/또는 소프트웨어가 획득되는 관할 법정의 법률 또는 규정 등 해당 법률 또는 규정을 위반하여 소프트웨어를 수출하거나 재수출하지 않는 것에 동의합니다.
  
15. 대리인 및 제 3자 구입.
  다른 사람이나 단체를 위해 소프트웨어를 구입하는 경우, 구입자는 본인에게 소프트웨어를 구입할 해당 단체 및 기관이 본 EULA의 약관을 준수하도록 규제할 수 있는 권한이 있음을 표시하고 보증해야 합니다. 사용자는 소프트웨어를 사용하거나 액세스하고 본 EULA를 체결할 수 있는 충분한 법적 연령이 사용자의 관할지에서 부합하다는 사실을 나타냅니다.
  
16. 준거법 및 분리.
  사용자가 미국에 있는 경우, 본 EULA는 법률 또는 법칙 선택 규정 적용에 관계없이 미국 법률과 캘리포니아주 법의 적용을 받으며 이에 따라 해석됩니다. 사용자가 미국 외 지역에 있는 경우, 본 EULA는 스위스 법의 적용을 받습니다. 본 EULA의 조항이 유효하지 않은 것으로 판단될 경우, 계약 당사자는 법원이 해당 조항에 반영된 대로 당사자의 의도에 대해 법적 조치를 취하며, EULA의 나머지 조항은 효력이 유효하고 유지됨에 동의합니다. 미국에 거주하고 본 소프트웨어 또는 제품을 개인용이나 가정용으로만 사용할 경우, 17절이 적용됩니다.
  
17. 중재.
  사용자와 긴트 사이에 발생하는 모든 분쟁은 미국 중재 협회의 소비자 중재 규칙(이하 "규칙")에 따라 시행된 구속력이 있는 최종 중재를 통해 해결됩니다. 단, 소액 배상 청구 법원의 관할 하에 있는 분쟁의 경우 당사자 중 한 사람의 선택에 따라 중재인 선임에 앞서 소관 관할 법원에 소집됩니다. 중재는 당사자 간의 상호 합의 또는 규칙에 명시된 선정 절차에 따라 선정된 단일 중재인이 수행해야 합니다. 중재 비용은 규칙에 명시된대로 당사자 간에 배분됩니다. 중재자의 판정은 최종적이며 항소권 없이 당사자들을 구속합니다. 증거의 유실을 막고 본 계약에 따라 제기되는 배상청구의 신속한 해결을 위해 본 EULA에 따라 배상청구를 하는 일방은 그 배상청구의 원인이 된 사건 또는 사실 발생일로부터 일(1)년 이내에, 또는 준거법에서 정한 최소 기한이 일(1)년을 초과할 경우 그 기한 내에 배상청구의 근거를 상대방에게 서면으로 고지해야 하며, 그렇지 않을 경우 그 일방은 해당 사건 또는 사실에 근거한 배상청구를 제기할 권리를 상실하게 됩니다.

18. 완전한 합의, 적용 언어.
  본 계약은 사용자와 긴트 간의 전체 계약을 명시하며 소프트웨어와 관련하여 서면 또는 구두로 이루어진 모든 이전 계약에 우선합니다. 본 EULA에 대한 번역은 해당 지역의 요구에 따라 이루어지며 영어와 비영어 버전 간의 불일치가 발생하는 경우, 본 EULA의 영어 버전이 우선됩니다. 본 소프트웨어는 미국 저작권법 및 국제 협약에 의해 보호됩니다. 본 소프트웨어의 무단 복제나 배포 시 민사 및 형사 책임이 적용될 수 있습니다.`,
};

const region = {
  header: '위치정보 이용약관',
  content: `
제1조 (목적)

본 약관은 회원(본 약관에 동의한 자를 말합니다. 이하 “회원”이라고 합니다)이 주식회사 긴트(이하 “회사”라고 합니다)가 제공하는 위치정보서비스 및 위치기반서비스(이하 “서비스”라고 합니다)를 이용함에 있어 회사와 회원의 권리•의무 및 책임사항을 규정함을 목적으로 합니다.

제2조 (약관의 효력 및 변경)

1. 본 약관은 서비스를 신청한 고객 또는 개인위치정보주체가 본 약관에 동의하고 회사가 정한 소정의 절차에 따라 서비스의 이용자로 등록함으로써 효력이 발생합니다.
2. 회사는 본 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 초기 화면에 게시하거나 기타의 방법으로 공지합니다.
3. 회사는 필요하다고 인정되면 본 약관을 변경할 수 있으며, 회사가 약관을 개정할 경우에는 기존약관과 개정약관 및 개정약관의 적용일자와 개정사유를 명시하여 현행약관과 함께 그 적용일자 7일 전부터 적용일 이후 상당한 기간 동안 공지합니다. 다만, 개정 내용이 회원에게 불리한 경우에는 그 적용일자 30일 전부터 적용일 이후 상당한 기간 동안 각각 이를 서비스 홈페이지에 게시하거나 회원에게 전자적 형태(전자우편, SMS 등)로 약관 개정 사실을 발송하여 고지합니다.
4. 회사가 전항에 따라 회원에게 공지하거나 통지하면서 공지 또는 통지ㆍ고지일로부터 개정약관 시행일 7일 후까지 거부의사를 표시하지 아니하면 승인한 것으로 본다는 뜻을 명확하게 고지하였음에도 불구하고 거부의 의사표시가 없는 경우에는 변경된 약관에 승인한 것으로 봅니다. 회원이 개정약관에 동의하지 않을 경우 회원은 이용계약을 해지할 수 있습니다.

제3조 (약관 외 준칙)

본 약관에 규정되지 않은 사항에 대해서는 위치정보의 보호 및 이용 등에 관한 법률(이하 “위치정보법”이라고 합니다), 전기통신사업법, 정보통신망 이용촉진 및 보호 등에 관한 법률(이하 “정보통신망법”이라고 합니다), 개인정보보호법 등 관련법령 또는 회사가 정한 서비스의 운영정책 및 규칙 등(이하 “세부지침”이라고 합니다)의 규정에 따르며, 개인정보 처리기준 및 보호조치 등에 관한 사항은 개인정보 처리방침을 통해 공개합니다.

제4조 (서비스의 가입)

1. 회사는 아래와 같은 경우에는 이용자의 가입신청을 승낙하지 않을 수 있습니다.
    1. 실명이 아니거나 다른 사람의 명의를 사용하는 등 허위로 신청하는 경우
    2. 회원 등록 사항을 빠뜨리거나 잘못 기재하여 신청하는 경우
    3. 기타 회사가 정한 이용신청 요건을 충족하지 않았을 경우

제5조 (서비스의 해지)

회원이 서비스 이용을 해지하고자 할 경우 회원은 회사가 정한 절차(서비스 홈페이지 등을 통해 공지합니다)를 통해 서비스 해지를 신청할 수 있으며, 회사는 법령이 정하는 바에 따라 신속히 처리합니다.

제6조 (서비스의 내용)

1. 서비스의 이용은 연중무휴 1일 24시간을 원칙으로 합니다. 단, 회사의 업무 또는 기술상의 이유로 서비스가 일시 중지될 수 있으며, 운영상의 목적으로 회사가 정한 기간에도 서비스는 일시 중지될 수 있습니다. 이때 회사는 사전 또는 사후에 이를 공지합니다.
2. 회사가 제공하는 서비스의 종류, 세부 내용은 ‘별표1. 서비스의 종류’ 에 따릅니다.

제7조 (서비스 이용요금)

1. 회사가 제공하는 서비스는 기본적으로 무료입니다. 회사가 별도의 유료서비스를 제공하는 경우에는 해당 서비스에서 요금을 명시합니다.
2. 회사는 유료서비스 이용요금을 회사와 계약한 전자지불업체에서 정한 방법에 의하거나 회사가 정한 청구서에 합산하여 청구할 수 있습니다.
3. 유료서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의 결제 이용약관 등 관련법령에 따릅니다.
4. 회원의 개인정보도용 및 결제사기로 인한 환불요청 또는 결제자의 개인정보 요구는 법률이 정한 경우 외에는 거절될 수 있습니다.
5. 무선서비스 이용 시 발생하는 데이터 통신료는 별도이며, 회원이 가입한 각 이동통신사의 정책에 따릅니다.
6. MMS 등으로 게시물을 등록할 경우 발생하는 요금은 회원이 가입한 각 이동통신사의 정책에 따릅니다.

제8조 (서비스의 이용제한 및 중지)

1. 회사는 아래 각 호의 경우에는 회원의 서비스 이용을 제한하거나 중지시킬 수 있습니다.
    1. 회원이 회사 서비스의 운영을 고의 또는 중과실로 방해하는 경우
    2. 서비스용 설비 점검, 보수 또는 공사로 인하여 부득이한 경우
    3. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우
    4. 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 때
    5. 기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이 부적당하다고 인정하는 경우
2. 회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을 회원에게 알려야 합니다.

제9조 (서비스내용변경 통지 등)

1. 회사가 서비스 내용을 변경하거나 종료하는 경우 회사는 전자적 형태(전자우편, SMS 등)의 방법을 통하여 서비스 내용의 변경 사항 또는 종료를 통지할 수 있습니다.
2. 전항의 경우 불특정 다수인을 상대로 통지를 함에 있어서는 서비스 홈페이지 등 기타 회사의 공지사항 페이지를 통하여 회원들에게 통지할 수 있습니다. 단, 회원 본인의 거래와 관련하여 중대한 영향을 미치는 사항은 상당한 기간 동안 서비스 홈페이지에 게시하거나 회원에게 전자적 형태(전자우편, SMS 등)로 개별통지 합니다.

제10조(위치정보의 수집 방법)

1. 회사는 위치정보 및 위치기반서비스를 제공하기 위하여 회원의 개인위치정보를 수집하며, 회원은 본 약관에 동의함으로써 이에 동의한 것으로 간주됩니다. 서비스 탈퇴 등의 방법을 통하여 개인위치정보의 수집에 관한 동의를 철회할 수 있습니다.
2. 회사는 다음과 같은 방식으로 개인위치정보를 수집하여, 회원에게 제6조 제2항의 서비스를 제공합니다.
    1. 휴대전화기기에 장착된 GPS 단말기를 이용하여 위치 정보를 수집함
3. 제2항에 따른 위치정보의 수집방법이 변경되는 경우 회사는 미리 홈페이지 등에 공지하거나 회원에게 별도 통지합니다. 다만 통제할 수 없는 사유가 발생하여 사전 통지가 불가능한 경우 사후 통지합니다.

제11조 (개인위치정보의 이용 또는 제공)

1. 회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 약관에 명시한 후 개인위치정보주체의 동의를 얻어야 합니다.
2. 회사는 제3자에게 개인위치정보를 제공하는 경우에는, 제공 받는자 및 제공목적을 사전에 개인위치정보주체에게 고지하고 동의를 받습니다. 다만, 다음의 경우는 예외로 하고 있습니다.
    1. 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
3. 회사는 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는 개인위치정보를 수집한 당해 통신 단말장치로 매회 회원에게 제공받는 자, 제공 일시 및 제공목적을 즉시 통보합니다. 단, 아래 각 호의 1에 해당하는 경우에는 회원이 미리 특정하여 지정한 통신 단말장치 또는 전자우편주소로 통보합니다.
    1. 개인위치정보를 수집한 당해 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우
    2. 회원이 온라인 게시 등의 방법으로 통보할 것을 미리 요청한 경우

제12조 (개인위치정보의 보유목적 및 보유기간)

1. 회사는 위치정보 및 위치기반서비스를 제공하기 위해 필요한 최소한의 개인위치정보를 보유 및 이용하며, 개인위치정보의 보유목적은 ‘별표1. 서비스의 종류’에 따릅니다.
2. 회사는 회원의 개인위치정보를 이용한 경우 위치정보법에 의하여 기록·보존하여야 하는 위치정보 이용·제공사실 확인자료 및 해당 개인위치정보를 회원 탈퇴 및 서비스 종료 시 지체 없이 파기합니다. 단, 관련 법령에 의한 보관이 필요한 경우 해당 기간만큼 보관합니다.

제13조 (위치정보 수집·이용·제공사실 확인자료의 보유)

1. 회사는 위치정보법 제16조 제2항에 근거하여 다른 사업자 또는 이용 고객과 요금정산 및 민원처리를 위해 위치정보 수집, 이용, 제공사실 확인자료를 위치정보시스템에 자동으로 기록하며, 해당 자료는 최소 6개월간 보존합니다.
2. 회사는 위치정보법 제24조 제4항에 따라 개인위치정보주체가 수집, 이용, 제공 동의의 전부 또는 일부를 철회한 경우 회사는 수집한 개인위치정보 및 수집ㆍ이용ㆍ제공사실 확인자료(동의의 일부를 철회하는 경우에는 철회하는 부분의 개인위치정보 및 위치정보 이용ㆍ제공사실 확인자료에 한합니다.)를 즉시 파기합니다 . 단, 관련 법령의 규정에 따라 보존할 필요가 있을 때에는 해당 법령에서 정한 바에 따라 보존합니다.

제14조 (개인위치정보주체의 권리)

1. 회원은 회사에 대하여 언제든지 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의의 전부 또는 일부를 철회할 수 있습니다.
2. 회원은 회사에 대하여 언제든지 개인위치정보의 수집, 이용 또는 제공의 일시적인 중지를 요구할 수 있으며, 회사는 이를 거절할 수 없고 이를 위한 기술적 수단을 갖추고 있습니다.
3. 회원은 회사에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 당해 자료에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다. 이 경우 회사는 정당한 사유 없이 회원의 요구를 거절할 수 없습니다.
    1. 본인에 대한 위치정보 수집, 이용, 제공사실 확인자료
    2. 본인의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률 규정에 의하여 제3자에게 제공된 이유 및 내용
4. 회원은 회사에서 정한 소정의 절차를 통해 제1항 내지 제3항의 내용을 요구할 수 있습니다.

제15조 (법정대리인의 권리)

1. 회사는 14세 미만의 회원에 대해서는 개인위치정보의 수집 및 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의를 당해 회원과 당해 회원의 법정대리인으로부터 받아야 합니다. 이 경우 법정대리인은 제14조에 의한 회원의 권리를 모두 가집니다.
2. 회사는 14세 미만의 아동의 개인위치정보 또는 위치정보 이용, 제공사실 확인자료를 이용약관에 명시 또는 고지한 범위를 넘어 이용하거나 제3자에게 제공하고자 하는 경우에는 14세 미만의 아동과 그 법정대리인의 동의를 받아야 합니다. 단, 아래의 경우는 제외합니다.
    1. 위치정보 및 위치기반서비스 제공에 따른 요금정산을 위하여 위치정보 이용, 제공사실 확인자료가 필요한 경우
    2. 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우

제16조 (8세 이하의 아동 등의 보호의무자의 권리)

1. 회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동 등”이라고 합니다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 수집, 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.
    1. 8세 이하의 아동
    2. 피성년후견인
    3. 장애인복지법 제2조 제2항 제2호의 규정에 따른 정신적 장애를 가진 자로서 장애인 고용촉진 및 직업재활법 제2조 제2호의 규정에 따라 중증장애인에 해당하는 자(장애인복지법 제32조의 규정에 따라 장애인등록을 한 자에 한합니다)
2. 전항의 규정에 따른 8세 이하 아동 등의 보호의무자는 해당 아동을 사실상 보호하는 자로서 다음 각 호에 해당하는 자를 말합니다.
    1. 8세 이하의 아동의 법정대리인 또는 보호시설에 있는 미성년자의 후견 직무에 관한 법률 제3조의 규정에 따른 후견인
    2. 피성년후견인의 법정대리인
    3. 본 조 제1항 제3호의 자의 법정대리인 또는 장애인복지법 제58조 제1항 제1호의 규정에 따른 장애인생활시설(국가 또는 지방자치단체가 설치·운영하는 시설에 한합니다)의 장, 정신보건법 제3조 제4호의 규정에 따른 정신질환자 사회복귀시설(국가 또는 지방자치단체가 설치·운영하는 시설에 한합니다)의 장, 동법 동조 제5호의 규정에 따른 정신요양시설의 장
3. 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 수집, 이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.
4. 보호의무자는 8세 이하의 아동 등의 개인위치정보 수집, 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.

제17조 (회사의 주소 및 연락처 등)

1. 회사의 상호, 주소 및 연락처는 아래와 같습니다.
- 상호 : (주)긴트
- 대표 : 김용현
- 주소 : 경기도 성남시 분당구 삼평동 633 판교세븐벤처밸리 2단지 1동 4층  마켓
- 대표전화 : 031-212-4994
1. 회사는 개인위치정보를 적절히 관리·보호하고, 개인위치정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수 있는 지위에 있는 자를 위치정보관리책임자로 지정해 운영하고 있으며, 위치정보관리책임자의 성명과 연락처는 아래와 같습니다.
- 위치정보 관리책임자 : 김용현
- 대표전화 : 031-212-4994
- 이메일 : support@gintlab.com

제18조 (양도금지)

회원의 서비스 받을 권리는 이를 양도 내지 증여하거나 담보제공 등의 목적으로 처분할 수 없습니다.

제19조 (손해배상)

1. 회사가 위치정보법 제15조 내지 제26조의 규정을 위반한 행위로 회원에게 손해가 발생한 경우 회원은 회사에 대하여 손해배상 청구를 할 수 있습니다. 이 경우 회사는 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.
2. 회원이 본 약관의 규정을 위반하여 회사에 손해가 발생한 경우 회사는 회원에 대하여 손해배상을 청구할 수 있습니다. 이 경우 회원은 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.

제20조 (면책)

1. 회사는 다음 각 호의 사유로 서비스를 제공할 수 없는 경우 이로 인하여 회원에게 발생한 손해에 대해서는 책임을 부담하지 않습니다.
    1. 천재지변 또는 이에 준하는 불가항력의 상태가 있는 경우
    2. 서비스 제공을 위하여 회사와 서비스 제휴계약을 체결한 제3자의 고의적인 서비스 방해가 있는 경우
    3. 회원의 귀책사유로 서비스 이용에 장애가 있는 경우
    4. 제1호 내지 제3호를 제외한 기타 회사의 고의ㆍ과실이 없는 사유로 인한 경우
2. 회사는 서비스 및 서비스에 게재된 정보, 자료, 사실의 신뢰도, 정확성 등에 대해서는 보증을 하지 않으며 이로 인해 발생한 회원의 손해에 대하여는 책임을 부담하지 아니합니다.

제21조(준거법 및 재판관할)

1. 본 약관은 대한민국법령에 의하여 규정되고 이행 됩니다.
2. 회원 및 법정대리인의 권리와 그 행사방법은 제소 당시의 이용자의 주소에 의하며, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경 우에는 민사소송법상의 관할법원에 제기합니다.

제22조 (분쟁의 조정 및 기타)

1. 서비스 이용과 관련하여 회사와 회원 간에 분쟁이 발생하면, 회사는 분쟁의 해결을 위해 회원과 성실히 협의합니다.
2. 전항의 협의에서 분쟁이 해결되지 않은 경우 회사와 회원은 위치정보법 제28조에 의한 방송통신위원회에 재정을 신청하거나, 개인정보보호법 제43조에 의한 방송통신위원회 또는 개인정보분쟁조정위원회에 재정 또는 분쟁조정을 신청할 수 있습니다.
3. 전항으로도 분쟁이 해결되지 않으면 회사와 회원 양 당사자는 민사소송법상의 관할법원에 소를 제기할 수 있습니다.`,
};

const personalinfomation = {
  header: '개인정보 수집 및 이용에 대한 안내',
  content: `
주식회사 긴트(이하 긴트)는 서비스, 마케팅, 고객상담 등의 원활한 제공을 목적으로 개인정보를 수집하며, 개인정보보호법 제15조, 제17조 및 제22조에 따라 귀하의 동의를 받고자 합니다.

1. 목적
  플루바 마켓 서비스, 마케팅, 고객상담(AICC) 등에서의 사용자 식별, 고객과의 원활한 의사소통, 비밀번호 및 계정 분실 시 본인확인 목적

2. 수집 항목
  계정, 이메일 주소, 비밀번호, 이름, 성별, 생년월일, 전화번호, 주소, 단말 정보(단말기 일련번호)

3. 개인정보 보유 및 이용 기간
  플루바 마켓 서비스 회원 탈퇴 시까지 보유 및 이용, 탈퇴 즉시 파기`,
};

const marketing = {
  header: '마케팅 목적 개인정보 수집‧이용',
  content: `
1. 목적
  컨텐츠 소개 발송 및 SMS를 통한 이벤트 참여 등 홍보 및 마케팅을 위한 목적

2. 수집 항목
  계정, 이메일 주소, 비밀번호, 이름, 성별, 생년월일, 전화번호, 주소

3. 개인정보 보유 및 이용기간
  플루바 마켓 서비스 회원 탈퇴 시까지 보유 및 이용, 탈퇴 즉시 파기`,
};

export const termsOfUse = { pluvaMarket, region, personalinfomation, marketing };
